import React, { useEffect } from 'react'

import { observer } from 'mobx-react'
import { useSnackbar } from 'notistack'
import { Redirect, useLocation } from 'react-router-dom'

import { adaptPostImportErrors } from 'shared/adapters/imports'
import { PRODUCT_ALREADY_IN_THE_INVENTORY_ERROR, PRODUCT_LIMIT_HAS_BEEN_REACHED } from 'shared/constants/retailerItems'

import { useStores } from 'retailer/stores/hooks'

const AlibabaAddProductRedirect = () => {
  const { importListPageStore } = useStores()
  const { enqueueSnackbar } = useSnackbar()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const itemId = searchParams.get('itemId')

  useEffect(() => {
    if (itemId) {
      importListPageStore.importAlibabaProduct(itemId).then(() => {
        enqueueSnackbar('Importing Alibaba Product', { variant: 'info' })
      }).catch((error) => {
        const { data, status } = error?.response || {}
        const adaptedErrors = status === 400
          ? adaptPostImportErrors(data?.errors)?.nonFieldErrors
          : null

        if (adaptedErrors?.includes(PRODUCT_ALREADY_IN_THE_INVENTORY_ERROR)) {
          enqueueSnackbar('Product wasn’t added because it’s already in your inventory.', { variant: 'error' })
        } else if (adaptedErrors?.includes(PRODUCT_LIMIT_HAS_BEEN_REACHED)) {
          enqueueSnackbar('Item wasn’t added. Your subscription plan limit has been reached.', { variant: 'error' })
        } else {
          enqueueSnackbar('Product wasn’t added. Refresh the page and try again.', { variant: 'error' })
        }
      })
    }
  }, [itemId])

  return <Redirect to="/my-products/import-list" />
}

export default observer(AlibabaAddProductRedirect)
